import { LegacyRef, MutableRefObject, useEffect, useRef } from 'react';

type ClickOutsideReturn = {
    ref?: LegacyRef<HTMLDivElement>;
};

function useClickOutside(
    onClickOutside: () => void,
    customRef?: MutableRefObject<unknown> | null,
    exclude: string[] = []
): ClickOutsideReturn {
    const fallbackRef = useRef<HTMLDivElement>(null);
    const ref = (customRef as MutableRefObject<HTMLDivElement | null>) || fallbackRef;

    useEffect(() => {
        if (document && typeof window !== 'undefined') {
            document.addEventListener('mousedown', onOutsideClick);
        }
        return () => {
            if (document && typeof window !== 'undefined') {
                document.removeEventListener('mousedown', onOutsideClick);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function onOutsideClick(event: MouseEvent | TouchEvent) {
        if (
            ref?.current &&
            ref?.current?.contains &&
            event.target instanceof Node &&
            !ref.current.contains(event.target)
        ) {
            // excluded divs are considered ok to be clicked outside
            const isInExcludedDivs = exclude?.some(
                (excludeDiv) =>
                    event.target instanceof Node && document.querySelector(excludeDiv)?.contains(event.target)
            );
            if (!isInExcludedDivs) {
                onClickOutside();
            }
        }
    }

    return {
        ref: ref
    };
}

export default useClickOutside;
